<template>
  <a-modal
    title="发放选项范围"
    width="550px"
    :visible="visible"
    okText="确认"
    :destroyOnClose="true"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form-model ref="baseForm" class="baseForm" :model="formData">
      <ls-metable
        class="allocationTable"
        :columns="columns"
        :data-list="formData.infos"
        :scroll="{y:400}"
        :customRow="(record, index) => index"
        :IsEdit="false"
        :needAdd="false"
      >
        <template slot="inOutText" slot-scope="{text, record}">
          <div>{{ inOutEnum[record.inOut] || '' }}</div>
        </template>
        <template slot="dateStart" slot-scope="{text,record,index}">
          <a-form-model-item
            :prop="`infos.${index}.dateStart`"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
          >
            <a-input-number
              v-model="record.dateStart"
              :min="0"
              :max="99999"
              :parser="(value) => `${value}`.replace(/\D/g, '')"
              :formatter="(value) => `${value}`.replace(/\D/g, '')" />
          </a-form-model-item>
        </template>
        <template slot="dateEnd" slot-scope="{text,record,index}">
          <a-form-model-item
            :prop="`infos.${index}.dateEnd`"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
          >
            <a-input-number
              v-model="record.dateEnd"
              :min="0"
              :max="99999"
              :parser="(value) => `${value}`.replace(/\D/g, '')"
              :formatter="(value) => `${value}`.replace(/\D/g, '')" />
          </a-form-model-item>
        </template>
      </ls-metable>
    </a-form-model>
    <template slot="footer">
      <a-button @click="visible=false;">取消</a-button>
      <a-button type="primary" :loading="confirmLoading" @click="confirm">确认</a-button>
    </template>
  </a-modal>
</template>

<script>
import { apiScpSetUpReleaseRadius, apiScpFindReleaseRadius } from '@/api/finished-goods-order'
export default {
  name: 'DistributionScopeModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      inOutEnum: { '10': '外部', '15': '内部' },
      formData: { infos: [] },
      columns: [
        { title: '内外部', dataIndex: 'inOutText', scopedSlots: { customRender: 'inOutText' }, align: 'center' },
        { title: '天数起', dataIndex: 'dateStart', scopedSlots: { customRender: 'dateStart' }, align: 'center' },
        { title: '天数止', dataIndex: 'dateEnd', scopedSlots: { customRender: 'dateEnd' }, align: 'center' }
      ]
    }
  },
  methods: {
    // 展示
    show () {
      this.initData()
      this.visible = true
    },
    // 关闭
    close() {
      this.visible = false
    },
    // 初始化查询发放范围
    initData() {
      this.$set(this.formData, 'infos', [])
      this.confirmLoading = true;
      apiScpFindReleaseRadius({}).then(res => {
        if (res?.code === 200 && res?.data) {
          this.$set(this.formData, 'infos', res?.data || [])
        }
      }).finally(() => {
        this.confirmLoading = false;
      })
    },
    // 确认
    confirm() {
      this.$refs.baseForm.validate(valid => {
        if(valid) {
          const params = this.formData.infos.map(obj => {
            return { inOut: obj.inOut, dateStart: obj.dateStart, dateEnd: obj.dateEnd }
          })
          this.confirmLoading = true;
          apiScpSetUpReleaseRadius(params).then(res => {
            if (res?.code === 200) {
              this.$message.success('操作成功')
              this.visible = false
              this.$emit("finallyWork")
            }
          }).finally(() => {
            this.confirmLoading = false;
          })
        } else { this.$message.warning('请检查必填项') }
      });
    }
  }
}
</script>
<style scoped lang="less">
.baseForm{
  .ant-form-item{
    margin-bottom: 0;
  }
  /deep/ .ant-form-explain, .ant-form-extra{
    min-height: 0;
  }
}
</style>
